export default __webpack_public_path__ + "static/media/012-highway.675cef2f.png";